module.exports = __webpack_public_path__ + "static/desktopHero-c9b5cad623aa93137e80f1e61d7fe0b8.png";